"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFilterPrettyPrint = createFilterPrettyPrint;
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const uom_1 = require("@genesys/uom");
const property_1 = require("@genesys/property");
const PropertyFiltering = __importStar(require("@promaster-sdk/property-filter-pretty"));
const ProductProperties = __importStar(require("@genesys/shared/lib/product-properties"));
const LanguageTexts = __importStar(require("@genesys/shared/lib/language-texts"));
function createFilterPrettyPrint(translatePropertyName, translatePropertyValue, translate, getAmountFormat, fieldGroup, getConversionParamaters
// productPropertiesMap: Map<string, GenesysPropertiesSelectorTypes.Property>
) {
    const filterPrettyMessages = {
        comparisionOperationMessage: (op, left, right) => {
            switch (op) {
                case "greater": {
                    return translate(LanguageTexts.shouldBeGreater(left, right));
                }
                case "greaterOrEqual": {
                    return translate(LanguageTexts.shouldBeGreaterOrEqual(left, right));
                }
                case "less": {
                    return translate(LanguageTexts.shouldBeLess(left, right));
                }
                case "lessOrEqual": {
                    return translate(LanguageTexts.shouldBeLessOrEqual(left, right));
                }
                default: {
                    (0, ts_exhaustive_check_1.exhaustiveCheck)(op);
                    return "";
                }
            }
        },
        equalsOperationMessage: (op, left, right) => {
            switch (op) {
                case "equals": {
                    return translate(LanguageTexts.shouldBeEquals(left, right));
                }
                case "notEquals": {
                    return translate(LanguageTexts.shouldBeNotEquals(left, right));
                }
                default: {
                    (0, ts_exhaustive_check_1.exhaustiveCheck)(op);
                    return "";
                }
            }
        },
        rangeMessage: (min, max) => translate(LanguageTexts.shouldBeBetweenMinMax(min, max)),
        andMessage: () => translate(LanguageTexts.and()),
        orMessage: () => translate(LanguageTexts.or()),
        propertyNameMessage: (propertyName) => translatePropertyName(propertyName, translate),
        propertyValueMessage: (propertyName, pv) => {
            switch (pv.type) {
                case "integer": {
                    return translatePropertyValue(propertyName, property_1.PropertyValue.getInteger(pv), translate);
                }
                case "text": {
                    return property_1.PropertyValue.getText(pv) || "";
                }
                case "amount": {
                    const conversionParamater = getConversionParamaters(propertyName);
                    const amountFormat = getAmountFormat(fieldGroup, propertyName, pv.value);
                    const format = uom_1.Format.getUnitFormat(amountFormat.unit, uom_1.UnitsFormat);
                    return `${ProductProperties.getValue(pv, amountFormat, conversionParamater)} ${format && format.label}`;
                }
                default: {
                    (0, ts_exhaustive_check_1.exhaustiveCheck)(pv);
                    return "missing property type translation";
                }
            }
        },
        nullMessage: () => translate(LanguageTexts.pNull())
    };
    return (pf) => PropertyFiltering.filterPrettyPrintIndented(filterPrettyMessages, 5, " ", pf, uom_1.UnitsFormat, uom_1.unitLookup);
}
//# sourceMappingURL=index.js.map